import React from "react";
import assest from "../../../json/assest";
import styles from "../../../styles/components/video.module.scss";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import TabPanel from "../../UtilitiesComponent/TabPanel";
import { getUtcDateTime } from "../../../lib/functions/utils.lib";
import InquringStatus from "./InquringStatus";
import RejectStatus from "./StatusComponent/RejectStatus";
import DeleteStatus from "./StatusComponent/DeleteStatus";
import WebsiteStatus from "./StatusComponent/WebsiteStatus";
import MultipleSubmission from "./MultipleSubmission";

const ShowVideoStatus = ({
  data,
  handleUpdate,
  notes,
  refetchNote,
  onClose,
}) => {
  const handleCancle = () => {
    handleUpdate(0);
  };

  return (
    <>
      <TabPanel value={data.status} index={0}>
        <Box className={`${styles.approveBox} ${styles.approveOrangeBox}`}>
          <p>
            This video is <b>pending</b> review
          </p>
          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img
                src={assest.crossBlack}
                onClick={onClose}
                width={21}
                height={21}
                alt=""
              />
            </Button>
          </Box>
        </Box>
      </TabPanel>
      <TabPanel value={data.status} index={1}>
        <Box className={styles.approveBox}>
          <p>
            You <b>Approved</b> this video on{" "}
            {getUtcDateTime(
              data.video_meta.admin_updated_at ||
                data.video_meta.quality_team_updated_at
            )}{" "}
          </p>
          <Button onClick={handleCancle}>
            <img src={assest.cancelIcon} width={14} height={14} alt="" /> Cancel
          </Button>
          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img
                src={assest.crossBlack}
                onClick={onClose}
                width={21}
                height={21}
                alt=""
              />
            </Button>
          </Box>
        </Box>
      </TabPanel>
      <TabPanel value={data.status} index={5}>
        <WebsiteStatus
          handleCancle={handleCancle}
          notes={notes}
          data={data}
          refetchNote={refetchNote}
          onClose={onClose}
        />
      </TabPanel>
      <TabPanel value={data.status} index={2}>
        <RejectStatus
          handleCancle={handleCancle}
          notes={notes}
          data={data}
          refetchNote={refetchNote}
          onClose={onClose}
        />
      </TabPanel>
      <TabPanel value={data.status} index={6}>
        <Box className={`${styles.approveBox} ${styles.approveGrayBox}`}>
          <p>
            You flagged this video as a duplication. on{" "}
            {getUtcDateTime(
              data.video_meta.admin_updated_at ||
                data.video_meta.quality_team_updated_at
            )}
          </p>
          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img
                src={assest.crossBlack}
                onClick={onClose}
                width={21}
                height={21}
                alt=""
              />
            </Button>
          </Box>
        </Box>
      </TabPanel>
      <TabPanel value={data.status} index={3}>
        <InquringStatus
          handleCancle={handleCancle}
          notes={notes}
          data={data}
          refetchNote={refetchNote}
          onClose={onClose}
        />
      </TabPanel>
      <TabPanel value={data.status} index={4}>
        <DeleteStatus
          handleCancle={handleCancle}
          notes={notes}
          data={data}
          refetchNote={refetchNote}
          onClose={onClose}
        />
      </TabPanel>
    </>
  );
};

export default ShowVideoStatus;
